(ns common.schema.entities.ai-summary-configuration.permissions
  (:require
   [common.roles :as roles]
   [common.schema.entities.ai-summary-configuration.options :as options]))

(defn entity-id
  [entity-or-id]
  (or (:db/id entity-or-id) entity-or-id))

(defn owner?
  [account configuration]
  (= (entity-id account)
     (entity-id (:common/owner configuration))))

(defn- explicit-use-access?
  [{:keys [account account-current-permissions]} configuration]
  (let [requester-ids (->> (get account-current-permissions
                                :account-team-memberships)
                           (cons (entity-id account))
                           (remove nil?)
                           set)]
    (->> (:ai-summary-configuration/use-access configuration)
         (map entity-id)
         (some requester-ids)
         boolean)))

(defn read-permissions?
  [{:keys [entity role] :as ctx}]
  (let [access-level
        (or (:ai-summary-configuration/configuration-access-level entity)
            options/access-level-private)]
    (and (roles/user? role)
         (case access-level
           :ai-summary-configuration.access-level/all-users true
           :ai-summary-configuration.access-level/restricted
           (or (owner? (:account ctx) entity)
               (explicit-use-access? ctx entity))
           (owner? (:account ctx) entity)))))

(defn disable-permissions?
  [{:keys [account entity tr]}]
  (when-not (owner? account entity)
    (tr :not-allowed)))
